import { collection, doc, getDoc, getDocs } from "firebase/firestore"
import { db } from "../../firebase/config"
import { message } from "antd"
import axiosInstance from "../../axios/axiosConfig"

export const handleCalculate = async (object, totalCount, truePrice = false) => {
  let materialEurM2 = 0
  let materialGM2 = 0
  let numberOfColumns = 0
  let labelHeight = 0
  let formatWidth = 0
  let selectedMachine = null
  // let kniveSpaceBetweenRows = 3
  let gapRaport = 3
  let pieregulesanaPiekartosana = 0
  let pieregulesanaCmykGatavieToni = 0
  let pieregulesanaPantone = 0
  let cmykColors = 0
  let cmykPercent = 1
  let pantoneColors = 0
  let pantonePercent = 0
  let coveringWCount = 0
  let coveringWPercent = 0
  let varnishXpretp = 0
  let varnishUse = 0
  let varnishPercent = 1
  let goldOrSilver = 0
  let goldOrSilverPercent = 0
  let reliefMeters = 0
  let reliefRunningMeters = 0
  let reliefTimePerMin = 0
  let selectedReliefUse = 0
  let foilCosts = 0
  let foilPercent = 0
  let foilCount = 0
  let secigaRazosana = 1
  let howManyTimes = 0
  let rastra = 0
  let krasuPaterinsCMYK = 0
  let krasuPaterinsPantone = 0
  let krasuPaterinsLaka = 0
  let krasuPaterinsZeltaKrasa = 0
  let krasuCenaEurKgLaka = 0
  let krasuCenaEurKgCMYK = 0
  let krasuCenaEurKgPantone = 0
  let krasuCenaEurKgZeltsUnSudrabs = 0
  let krasuCenaEurKgSedzosaKrasaW = 0
  let machineSpeed = 0
  let machineElectricity = 0
  let machineWorker = 0
  let machineAmortization = 0
  let productionCosts = 0
  let productionRunningMetersMin = 0
  let productionTimePerMinute = 0
  let productionCosts2 = 0
  let productionRunningMetersMin2 = 0
  let productionTimePerMinute2 = 0
  let hotprintMeterPerMin = 0
  let hotprintCostsPerH = 0
  let hotprintAdjustmentTimeMin = 0
  let hotprintAdjustmentRunningMeters = 0
  let extraProfitSlider = 0
  let clientsProfit = 0
  let userExtraPercent = 0
  //def values
  // Declare variables
  // pirma rinda tabula
  let cenaMaterialamKopaEurM2 = 0

  // otra rinda tabula
  let rinduSkaits = 1
  let skIzklajuma = 0

  //tresa rinda
  let krasuSk = 0
  let krasasPaterinsGM2 = 0
  let vidCenaKrasaiEurKg = 0

  let pieregulesanasLaiksMin = 0
  let pieregulesanasTM = 0
  let razosanasLaiksMin = 0

  let tirieTekosieMetri = 0
  let tirieM2 = 0
  let tehnologiskieZudumiM2 = 0

  let materialaIzmaksasEur = 0
  let visparejasIzmaksas = 0
  let VC = 0
  let elektriba = 0
  let krasasPaterinsEur = 0

  // Pieregulesanas laiks sadalijuma pa krasam min.
  let laiksMinCMYK = 10
  let laiksMinPantone = 11
  let pecapstrade1PieregulesanaM2 = 0

  //Pecapstrade 1, 2 un 3;
  let pecapstrade1VisparejasIzmaksas = 0
  let pecapstrade1RazosanasLaiksMin = 0
  let pecapstradeElektribaEur = 0

  // Produkcijas Komplektesana
  let produkcijasKomplektesanaElektribaEur = 0
  let produkcijasKomplektesanaVisparejasIzmaksas = 0
  let produkcijasKomplektesanaRazosanasLaiks = 0

  let produkcijasKomplektesana2ElektribaEur = 0
  let produkcijasKomplektesana2VisparejasIzmaksas = 0
  let produkcijasKomplektesana2RazosanasLaiks = 0

  let productionMaterialCosts = 0

  // transports
  let transportsCena = 0
  let transports = 0
  let tiraisSvarsKg = 0

  let pardosanasSummaEur = 0
  let kopejasIzmaksas = 0

  // main settings default
  let razosanasIzmaksas = 0
  let cenaPar1000uzlimemEur = 0

  //hotfoil or hotprint
  let hotprintProductionTimePerMin = 0
  let hotprintTotalCosts = 0
  let hotprintElectricity = 0
  let hotprintMaterialCosts = 0
  let hotprintAdjustmentM2 = 0
  let hotprintCost = 0

  //fetches material
  const fetchMaterial = async (object) => {
    const materialRef = doc(db, "materials", object.materialId)
    try {
      await getDoc(materialRef).then((docSnap) => {
        if (docSnap.exists()) {
          let materialData = docSnap.data()
          materialEurM2 = Number(materialData.eurM2)
          materialGM2 = Number(materialData.gM2)
        } else {
          console.log("No such material!")
        }
      })
    } catch (error) {
      message.error("error fetching material")
      console.log(error)
    }
  }
  // Modify the functions to update the variables directly

  //fetches knife details from API using the code
  const fetchKnife = async (code, fallbackObject) => {
    // Pass the main object for fallbacks
    try {
      // If the code explicitly indicates a new knife, use fallbacks directly
      if (code === "New Knife") {
        console.log("Using fallback dimensions for 'New Knife'")
        gapRaport = 3 // Default or maybe from fallbackObject.startup.newKnifeObject?
        labelHeight = parseInt(fallbackObject.labelHeight, 10) // Use main object's height
        numberOfColumns = fallbackObject.numberOfColumns // Use main object's columns
        return // Exit the function early
      }

      console.log(`Workspaceing knife with code: ${code}`)
      const response = await axiosInstance.get(`/api/searchByCode?code=${encodeURIComponent(code)}`)
      console.log("API Response Status:", response.status)
      console.log("API Response Data:", response.data)

      // Check if response AND response.data exist and have necessary properties
      if (response && response.data && response.data.spaceBetweenRows !== undefined) {
        let knifeData = response.data
        gapRaport = knifeData.gapRaport
        labelHeight = parseInt(knifeData.height, 10) // Ensure height is a number
        numberOfColumns = knifeData.rowss
        console.log(
          `Workspaceed knife data: Rows=${numberOfColumns}, Height=${labelHeight}, Space=${gapRaport}`,
        )
      } else {
        // API responded, but no valid knife data found for the code
        message.warning(`Knife code "${code}" not found in API, using default/fallback dimensions.`)
        console.warn(`Knife code "${code}" not found in API response data:`, response.data)
        gapRaport = 3 // Default fallback
        labelHeight = parseInt(fallbackObject.labelHeight, 10) // Fallback to main object's height
        numberOfColumns = fallbackObject.numberOfColumns // Fallback to main object's columns
      }
    } catch (error) {
      console.error(`Failed to fetch knife data for code "${code}":`, error)
      message.error(
        `Failed to fetch knife data for code "${code}", using default/fallback dimensions.`,
      )
      // Apply fallbacks on API error
      gapRaport = 3
      labelHeight = parseInt(fallbackObject.labelHeight, 10) // Fallback to main object's height
      numberOfColumns = fallbackObject.numberOfColumns // Fallback to main object's columns
    }
  }

  const fetchAdjustmentTM = async () => {
    const adjustmentRef = collection(db, "adjustmentTM")

    try {
      await getDocs(adjustmentRef).then((snapshot) => {
        let results = []
        snapshot.docs.forEach((doc) => {
          results.push({ id: doc.id, ...doc.data() })
        })
        const adjustingCleanResults = results.find((item) => item.type === "Adjustment Cleanup")
        pieregulesanaPiekartosana = Number(adjustingCleanResults.time)
        const adjustmentCMYK = results.find((item) => item.type === "Adjustment CMYK")
        pieregulesanaCmykGatavieToni = Number(adjustmentCMYK.time)
        const adjustmentPantone = results.find((item) => item.type === "Adjustment Pantone")
        pieregulesanaPantone = Number(adjustmentPantone.time)
      })
    } catch (error) {
      message.error("error fetching adjustmentTM")
      console.log(error)
    }
  }
  // Modify the functions to update the variables directly
  const fetchVarnish = async (object) => {
    if (object.print.varnishId !== null) {
      const varnishRef = doc(db, "varnish", object.print.varnishId)

      try {
        await getDoc(varnishRef).then((docSnap) => {
          if (docSnap.exists()) {
            let varnishData = docSnap.data()
            varnishXpretp = varnishData.xpretp
            varnishUse = varnishData.used
            varnishPercent = 1
          } else {
            console.log("No such varnish!")
          }
        })
      } catch (error) {
        message.error("error fetching varnish")
        console.log(error)
      }
    } else {
      varnishXpretp = 0
      varnishUse = 0
      varnishPercent = 1
    }
  }

  const fetchRelief = async (object) => {
    if (object.print.reliefId !== null) {
      const reliefRef = doc(db, "relief", object.print.reliefId)
      try {
        await getDoc(reliefRef).then((docSnap) => {
          if (docSnap.exists()) {
            let reliefData = docSnap.data()
            reliefMeters = reliefData.meters
            reliefRunningMeters = reliefData.runningMeters
            reliefTimePerMin = reliefData.timePerMin
          } else {
            console.log("No such relief!")
          }
        })
      } catch (error) {
        message.error("error fetching relief")
        console.log(error)
      }
    } else {
      reliefMeters = 0
      reliefRunningMeters = 0
      reliefTimePerMin = 0
    }
  }

  const fetchFoil = async (object) => {
    if (object.print.foilId !== null) {
      const foilRef = doc(db, "foil", object.print.foilId)
      try {
        await getDoc(foilRef).then((docSnap) => {
          if (docSnap.exists()) {
            let foilData = docSnap.data()
            foilCosts = foilData.costs
            foilPercent = object.foilPercent
            foilCount = object.foilCount
          } else {
            console.log("No such foil!")
          }
        })
      } catch (error) {
        message.error("error fetching foil")
        console.log(error)
      }
    } else {
      foilCosts = 0
      foilPercent = 0
      foilCount = 0
    }
  }
  // Color Consumption
  const fetchColorConsumption = async () => {
    const colorRef = collection(db, "krasuPaterins")
    try {
      await getDocs(colorRef).then((snapshot) => {
        let results = []
        snapshot.docs.forEach((doc) => {
          results.push({ id: doc.id, ...doc.data() })
        })
        const cmykResult = results.find((item) => item.type === "CMYK")
        krasuPaterinsCMYK = Number(cmykResult.consumption)
        const pantoneResult = results.find((item) => item.type === "Pantone")
        krasuPaterinsPantone = Number(pantoneResult.consumption)
        const varnishResult = results.find((item) => item.type === "Varnish")
        krasuPaterinsLaka = Number(varnishResult.consumption)
        const goldResult = results.find((item) => item.type === "Gold")
        krasuPaterinsZeltaKrasa = Number(goldResult.consumption)
      })
    } catch (error) {
      message.error("error fetching color consumption")
      console.log(error)
    }
  }

  // Color Price
  const fetchColorPrice = async () => {
    const colorPriceRef = collection(db, "colorPrices")

    try {
      await getDocs(colorPriceRef).then((snapshot) => {
        let results = []
        snapshot.docs.forEach((doc) => {
          results.push({ id: doc.id, ...doc.data() })
        })
        const varnishPriceResult = results.find((item) => item.type === "Varnish")
        krasuCenaEurKgLaka = Number(varnishPriceResult.price)
        const cmykPriceResult = results.find((item) => item.type === "CMYK")
        krasuCenaEurKgCMYK = Number(cmykPriceResult.price)
        const pantonePriceResult = results.find((item) => item.type === "Pantone")
        krasuCenaEurKgPantone = Number(pantonePriceResult.price)
        const goldPriceResult = results.find((item) => item.type === "GoldAndSilver")
        krasuCenaEurKgZeltsUnSudrabs = Number(goldPriceResult.price)
        const coveringWPriceResult = results.find((item) => item.type === "CoverW")
        krasuCenaEurKgSedzosaKrasaW = Number(coveringWPriceResult.price)
      })
    } catch (error) {
      message.error("Error fetching color prices")
      console.log(error)
    }
  }
  // Machine fetch
  const fetchMachine = async (object) => {
    const machinesRef = collection(db, "machines")
    try {
      await getDocs(machinesRef).then((snapshot) => {
        let results = []
        snapshot.docs.forEach((doc) => {
          results.push({ id: doc.id, ...doc.data() })
        })
        const currentMachine = results.find((data) => data.machine === object.machine)
        machineSpeed = currentMachine.speed
        machineElectricity = currentMachine.costs.electricity
        machineWorker = currentMachine.costs.worker
        machineAmortization = currentMachine.costs.amortization
      })
    } catch (error) {
      message.error("Error fetching machine")
      console.log(error)
    }
  }

  // Fetch production machine
  const fetchProductionMachine = async () => {
    const porductDefaultRef = doc(db, "productionCosts", "ygJHdF8Z6y3uR5H567BY")
    const porductDefaultRef2 = doc(db, "productionCosts", "GalDdGckTxeJHAEoD4nA")

    try {
      await getDoc(porductDefaultRef2).then((doc) => {
        let result = doc.data()
        productionCosts2 = result.costs
        productionRunningMetersMin2 = result.runningMetersMin
        productionTimePerMinute2 = result.timeperminute
      })

      await getDoc(porductDefaultRef).then((doc) => {
        let result = doc.data()
        productionCosts = result.costs
        productionRunningMetersMin = result.runningMetersMin
        productionTimePerMinute = result.timeperminute
      })
    } catch (error) {
      message.error("Production machine error")
      console.log(error)
    }
  }

  // Fetching hotprint
  const fetchHotprint = async () => {
    try {
      const hotprintRef = doc(db, "hotprint", "GDmYoXX9pwy61D8N1zDl")
      await getDoc(hotprintRef).then((doc) => {
        const hotprintData = doc.data()
        hotprintMeterPerMin = hotprintData.meterPerMinute
        hotprintCostsPerH = hotprintData.printCostsPerHour
        hotprintAdjustmentTimeMin = hotprintData.adjustmentTime
        hotprintAdjustmentRunningMeters = hotprintData.adjustmentRunningMeters
      })
    } catch (error) {
      message.error("error fetching hotprint")
      console.log(error)
    }
  }

  // Fetching user
  const fetchUser = async (object) => {
    const userDocRef = doc(db, "users", object.user)
    try {
      await getDoc(userDocRef).then((docSnap) => {
        if (docSnap.exists()) {
          const user = docSnap.data()
          userExtraPercent = user.extraPercentage
        } else {
          // doc.data() will be undefined in this case
          console.log("No such document!")
        }
      })
    } catch (error) {
      message.error("problems fetching user")
      console.log(error)
    }
  }

  // Fill order without fetching
  const noFetchingData = (object) => {
    formatWidth = object.formatWidth
    selectedMachine = object.machine
    cmykColors = object.print.cmykColors
    pantoneColors = object.print.pantoneColors
    pantonePercent = object.print.pantonePercent
    coveringWCount = object.print.coveringWCount
    coveringWPercent = object.print.coveringWPercent
    cmykPercent = 1
    goldOrSilver = object.print.goldOrSilver
    goldOrSilverPercent = object.print.goldOrSilverPercent
    howManyTimes = object.advanced.howManyTimes
    secigaRazosana = object.advanced.sequentialProduction
    rastra = object.advanced.rastra
    if (object.print.relief === "No") {
      selectedReliefUse = 0
    } else {
      selectedReliefUse = 1
    }
    clientsProfit = object.clientsProfit
    extraProfitSlider = object.advanced.extraProfit
  }
  noFetchingData(object)

  try {
    await Promise.all([
      fetchMaterial(object),
      fetchKnife(object.knifeCode, object),
      fetchAdjustmentTM(),
      fetchVarnish(object),
      fetchRelief(object),
      fetchFoil(object),
      fetchColorConsumption(),
      fetchColorPrice(),
      fetchMachine(object),
      fetchProductionMachine(object),
      fetchHotprint(),
      fetchUser(object),
    ])
  } catch (error) {
    console.error("An error occurred:", error)
  }

  cenaMaterialamKopaEurM2 = materialEurM2
  skIzklajuma = numberOfColumns * rinduSkaits
  let formataAugstums = Number(labelHeight) + Number(gapRaport)
  tirieM2 = (((formataAugstums * formatWidth) / 1000000) * totalCount) / skIzklajuma
  tirieTekosieMetri = (tirieM2 / formatWidth) * 1000
  if (selectedMachine === null) {
    pieregulesanasTM = 0
  } else {
    pieregulesanasTM =
      pieregulesanaPiekartosana +
      pieregulesanaCmykGatavieToni * cmykColors +
      pantoneColors * pieregulesanaPantone +
      coveringWCount * pieregulesanaPantone +
      goldOrSilver * pieregulesanaPantone +
      (tirieTekosieMetri > 2000 ? tirieTekosieMetri * 0.05 : tirieTekosieMetri * 0.1) +
      (howManyTimes - 1) * 80 +
      (secigaRazosana - 1) * 350
  }
  tehnologiskieZudumiM2 = (pieregulesanasTM * formatWidth) / 1000
  krasasPaterinsGM2 =
    cmykColors * krasuPaterinsCMYK * cmykPercent +
    pantonePercent * (pantoneColors === 0 ? 0 : 1) * krasuPaterinsPantone +
    (varnishXpretp === 0 ? 0 : varnishPercent * varnishXpretp * krasuPaterinsLaka) +
    goldOrSilverPercent * goldOrSilver * krasuPaterinsZeltaKrasa +
    (coveringWCount === 0 ? 0 : coveringWPercent * coveringWCount) * rastra
  krasasPaterinsGM2 = krasasPaterinsGM2.toFixed(2)
  krasasPaterinsGM2 = Number(krasasPaterinsGM2)

  vidCenaKrasaiEurKg =
    ((1000 / krasasPaterinsGM2) *
      (cmykPercent * cmykColors * krasuPaterinsCMYK * krasuCenaEurKgCMYK +
        pantonePercent *
          (pantoneColors === 0 ? 0 : 1) *
          krasuPaterinsPantone *
          krasuCenaEurKgPantone +
        (varnishUse === 0
          ? 0
          : varnishPercent * varnishXpretp * krasuPaterinsLaka * krasuCenaEurKgLaka) +
        goldOrSilverPercent *
          goldOrSilver *
          krasuPaterinsZeltaKrasa *
          krasuCenaEurKgZeltsUnSudrabs +
        (coveringWCount === 0 ? 0 : coveringWPercent * krasuCenaEurKgSedzosaKrasaW) *
          coveringWCount *
          rastra)) /
    1000
  vidCenaKrasaiEurKg = vidCenaKrasaiEurKg.toFixed(2)
  vidCenaKrasaiEurKg = Number(vidCenaKrasaiEurKg)

  if (krasasPaterinsGM2 === 0) {
    krasasPaterinsEur = 0
  } else {
    krasasPaterinsEur =
      (((tirieM2 + tehnologiskieZudumiM2 * 0.5) * krasasPaterinsGM2) / 1000) * vidCenaKrasaiEurKg
  }
  krasasPaterinsEur = krasasPaterinsEur.toFixed(2)
  krasasPaterinsEur = Number(krasasPaterinsEur)

  krasuSk = cmykColors + pantoneColors + goldOrSilver + coveringWCount

  if (selectedMachine === null) {
    razosanasLaiksMin = 0
  } else {
    razosanasLaiksMin = tirieTekosieMetri / machineSpeed
    razosanasLaiksMin = razosanasLaiksMin.toFixed(2)
    razosanasLaiksMin = Number(razosanasLaiksMin)
  }

  if (selectedMachine === null) {
    pieregulesanasLaiksMin = 0
  } else {
    pieregulesanasLaiksMin = Math.round(
      cmykColors * laiksMinCMYK +
        pantoneColors * laiksMinPantone +
        coveringWCount * laiksMinPantone +
        goldOrSilver * laiksMinCMYK +
        20 -
        (krasuSk > 6 ? (krasuSk - 6) * 20 * 0.4 : 0) +
        (howManyTimes - 1) * 60 +
        (secigaRazosana - 1) *
          ((cmykColors * laiksMinCMYK +
            pantoneColors * laiksMinPantone +
            coveringWCount * laiksMinPantone +
            goldOrSilver * laiksMinCMYK) *
            0.6 -
            (krasuSk > 6 ? (krasuSk - 6) * 20 * 0.4 : 0)),
    )
  }

  pecapstrade1PieregulesanaM2 = (reliefRunningMeters * formatWidth) / 1000

  if (selectedReliefUse === 1) {
    productionMaterialCosts = materialEurM2 * (pecapstrade1PieregulesanaM2 + tirieM2)
  } else {
    productionMaterialCosts = 0
  }

  if (reliefRunningMeters === 0) {
    pecapstrade1RazosanasLaiksMin = 0
  } else {
    pecapstrade1RazosanasLaiksMin = tirieTekosieMetri / reliefMeters
  }

  produkcijasKomplektesana2RazosanasLaiks = tirieTekosieMetri / productionRunningMetersMin2

  produkcijasKomplektesanaRazosanasLaiks = tirieTekosieMetri / productionRunningMetersMin

  elektriba = ((pieregulesanasLaiksMin + razosanasLaiksMin) / 60) * 15 * 0.34
  elektriba = elektriba.toFixed(2)
  elektriba = Number(elektriba)

  visparejasIzmaksas =
    ((machineElectricity + machineWorker + machineAmortization) *
      (pieregulesanasLaiksMin + razosanasLaiksMin)) /
    60
  visparejasIzmaksas = visparejasIzmaksas.toFixed(2)
  visparejasIzmaksas = Number(visparejasIzmaksas)

  materialaIzmaksasEur =
    (tirieM2 + tehnologiskieZudumiM2) * cenaMaterialamKopaEurM2 + krasasPaterinsEur
  materialaIzmaksasEur = materialaIzmaksasEur.toFixed(2)
  materialaIzmaksasEur = Number(materialaIzmaksasEur)

  VC = (materialaIzmaksasEur + visparejasIzmaksas) * (1 + Number(clientsProfit / 100)) * 0.07
  VC = VC.toFixed(2)
  VC = Number(VC)

  tiraisSvarsKg = ((132 + krasasPaterinsGM2 * 0.3) / 1000) * tirieM2

  tiraisSvarsKg = Number(tiraisSvarsKg.toFixed(2))

  transports = transportsCena * tiraisSvarsKg

  produkcijasKomplektesana2ElektribaEur = (productionTimePerMinute2 / 60) * 15 * 0.12

  produkcijasKomplektesanaElektribaEur = (productionTimePerMinute / 60) * 15 * 0.12

  produkcijasKomplektesana2VisparejasIzmaksas =
    (productionCosts2 * (productionTimePerMinute2 + produkcijasKomplektesana2RazosanasLaiks)) / 60

  produkcijasKomplektesanaVisparejasIzmaksas =
    (productionCosts * (productionTimePerMinute + produkcijasKomplektesanaRazosanasLaiks)) / 60

  pecapstradeElektribaEur = (reliefTimePerMin / 60) * 20 * 0.15
  pecapstradeElektribaEur = pecapstradeElektribaEur.toFixed(2)
  pecapstradeElektribaEur = Number(pecapstradeElektribaEur)

  pecapstrade1VisparejasIzmaksas = (reliefTimePerMin + pecapstrade1RazosanasLaiksMin) / 60

  razosanasIzmaksas = materialaIzmaksasEur + visparejasIzmaksas + VC + elektriba

  if (foilCount > 0) {
    hotprintProductionTimePerMin = tirieTekosieMetri / hotprintMeterPerMin
    hotprintProductionTimePerMin = Math.floor(hotprintProductionTimePerMin)

    hotprintTotalCosts =
      (hotprintCostsPerH * (hotprintAdjustmentTimeMin + hotprintProductionTimePerMin)) / 60

    hotprintElectricity = (hotprintAdjustmentTimeMin / 60) * 20 * 0.15

    hotprintAdjustmentM2 = (hotprintAdjustmentRunningMeters * formatWidth) / 1000

    hotprintMaterialCosts = foilCosts * (hotprintAdjustmentM2 + tirieM2) * foilPercent

    hotprintCost = hotprintMaterialCosts + hotprintElectricity + hotprintTotalCosts
  }

  kopejasIzmaksas =
    razosanasIzmaksas +
    pecapstrade1VisparejasIzmaksas +
    productionMaterialCosts +
    pecapstradeElektribaEur +
    produkcijasKomplektesanaVisparejasIzmaksas +
    produkcijasKomplektesana2VisparejasIzmaksas +
    produkcijasKomplektesanaElektribaEur +
    produkcijasKomplektesana2ElektribaEur +
    hotprintCost +
    transports

  pardosanasSummaEur =
    kopejasIzmaksas *
    (1 +
      Number(clientsProfit / 100) +
      Number(extraProfitSlider / 100) +
      Number(userExtraPercent / 100))

  console.log("--- BREAKDOWN ---")
  console.log("tirieM2:", tirieM2)
  console.log("tirieTekosieMetri:", tirieTekosieMetri)
  console.log("materialEurM2:", materialEurM2)
  console.log("materialaIzmaksasEur:", materialaIzmaksasEur)
  console.log("machineE+W+A:", machineElectricity, machineWorker, machineAmortization)
  console.log("pieregulesanasLaiksMin:", pieregulesanasLaiksMin)
  console.log("razosanasLaiksMin:", razosanasLaiksMin)
  console.log("visparejasIzmaksas:", visparejasIzmaksas)
  console.log("razosanasIzmaksas:", razosanasIzmaksas)
  console.log(
    "productionCosts:",
    productionCosts,
    "runningMin:",
    productionRunningMetersMin,
    "timePMin:",
    productionTimePerMinute,
  )
  console.log(
    "productionCosts2:",
    productionCosts2,
    "runningMin2:",
    productionRunningMetersMin2,
    "timePMin2:",
    productionTimePerMinute2,
  )
  console.log(
    "produkcijasKomplektesanaVisparejasIzmaksas:",
    produkcijasKomplektesanaVisparejasIzmaksas,
  )
  console.log(
    "produkcijasKomplektesana2VisparejasIzmaksas:",
    produkcijasKomplektesana2VisparejasIzmaksas,
  )
  let tirasCenasPardosana =
    kopejasIzmaksas * (1 + Number(0 / 100) + Number(0 / 100) + Number(0 / 100))

  let tiraCena = (tirasCenasPardosana / Number(totalCount)) * 1000
  tiraCena = tiraCena.toFixed(2)
  tiraCena = Number(tiraCena)

  let systemPrice = truePrice ? kopejasIzmaksas : pardosanasSummaEur

  cenaPar1000uzlimemEur = (systemPrice / Number(totalCount)) * 1000

  cenaPar1000uzlimemEur = cenaPar1000uzlimemEur.toFixed(2)
  cenaPar1000uzlimemEur = Number(cenaPar1000uzlimemEur)

  let papiraPaterins = (tirieM2 + tehnologiskieZudumiM2).toFixed(2)
  papiraPaterins = Number(papiraPaterins)

  return { cenaPar1000uzlimemEur, papiraPaterins, tiraisSvarsKg, totalCount, tiraCena }
}
